"use client";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useStoreContext } from "@components/store/provider";

import QuantitySelector from "@components/store/product-detail/shared/quantity-selector";
import { ProductListingContext } from "@components/store/products/listing/listing-provider";

import useStoreCurrencyConverter from "@hooks/currency/use-store-currency-converter";

import { getStorePriceShouldRoundOff } from "@selectors/store";

import { getProductFromBoxList } from "@helpers/orders/byo-box";

import { US_CURRENCY_CODE } from "@constants/store";
import { DEFAULT_QUANTITY } from "@constants/products/listing";

import { getMinPriceVariant } from "@helpers/product-details";

import styles from "./product-tile.module.scss";

//Using only in the case of BYO product

const ProductQuantitySelector = ({
  data,
  productQtyBlockClass = "",
  source,
  addToBox,
  removeFromBox,
  disabled = false,
}) => {
  const { variants = [] } = data;

  const [quantity, setQuantity] = useState(DEFAULT_QUANTITY.box);
  const { boxProductList } = useContext(ProductListingContext);
  const priceShouldRoundOff = useSelector(getStorePriceShouldRoundOff);

  const { storeCurrencyCode } = useStoreContext();
  const { convertPriceInStoreCurrency } = useStoreCurrencyConverter();
  const priceInUSD = source === "search";

  useEffect(() => {
    const productInBox =
      boxProductList &&
      getProductFromBoxList({
        externalId: getMinPriceVariant(variants)?.externalId,
        boxProductList,
      });
    if (!productInBox) {
      setQuantity(0);
    } else {
      setQuantity(productInBox.count);
    }
  }, [boxProductList]);

  const handleQuantity = (newQuantity) => {
    setQuantity(newQuantity);
    const currencyCode = priceInUSD ? US_CURRENCY_CODE : storeCurrencyCode;
    const options = {
      ceilRequired: priceShouldRoundOff,
    };
    const extractedVariants = getMinPriceVariant(variants);

    const product = {
      ...data,
      prices: extractedVariants.prices.map((price) =>
        convertPriceInStoreCurrency(price, currencyCode, options),
      ),
    };
    addToBox({
      externalId: extractedVariants?.externalId,
      newQuantity,
      product,
    });
  };

  const handleZeroQuantity = (externalId) => {
    setQuantity(0);
    removeFromBox(externalId);
  };

  return (
    <div className={`${styles.tileQtyBlock} ${productQtyBlockClass}`}>
      <QuantitySelector
        quantity={quantity}
        setQuantity={handleQuantity}
        minOrderableQuantity={0}
        onZeroHandler={() => handleZeroQuantity(getMinPriceVariant(variants)?.externalId)}
        className="defaultStyle"
        disabled={disabled}
      />
    </div>
  );
};

export default ProductQuantitySelector;
